module.exports = __webpack_public_path__ + "img/ggl_notice_bg.b31d383f.png";